// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  supabaseUrl: 'https://bwksnvqjafivjguwumwg.supabase.co',
  supabaseApiUrl: 'https://bwksnvqjafivjguwumwg.supabase.co/functions/v1',
  supabaseKey: 'sb_publishable_0hnZM5j0o6l5eGqhg-6SjA_nDjpTQyn',
  revenueCatApiKey: {
    android: 'goog_igKaeHXjzoDdjCLMedUzqeGblJs',
    ios: 'appl_fGdUHIEwLgGJjqEpYGyxmGgTANi',
    web: 'rcb_sb_fIKFRZOrLfzTbEgsQjSxLzpOA',
  },
  appRedirectUrl: 'https://app-dev.lyfeplum.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
